import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import PermissionsGate from 'components/Users/PermissionsGate';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import Table from 'components/new_ui/Table';
import { useContext } from 'components/Managers/Members/Context';
import { useContext as useUsersContext } from 'components/Users/Context';

import useIot from 'components/Common/Iot/Hooks/useIot';
import { PubSub } from 'aws-amplify';

export default function Index({ members, cancelCallback, sentCallback }) {
  const inviteDefaultText = 'Please wait, we will start invite process soon.';
  const { actions, state } = useContext();
  const [loading, setLoading] = useState(false);
  const [inviteInProgres, setInviteInProgres] = useState(false);
  const [inviteProgressText, setInviteProgressText] = useState(inviteDefaultText);

  useIot();

  const { state: stateUsers } = useUsersContext();

  useEffect(() => {
    if (stateUsers.user) {
      PubSub.subscribe(`user-${stateUsers.user.attributes.token}`).subscribe({
        next: ({ value }) => {
          if (value.type === 'invite_progress') {
            setInviteProgressText(`Sending the invitations: ${value.message}`);
          }
          if (value.type === 'invite_progress_finish') {
            setInviteProgressText(inviteDefaultText);
            setInviteInProgres(false);
            sentCallback();
          }
        },
      });
    }
  }, [stateUsers.user]);

  const columns = [
    {
      name: 'Name',
      selector: (row) => row.attributes.full_name,
      sortable: true,
      searchable: false,
    },
    {
      name: 'Email',
      selector: (row) => row.attributes.email,
      sortable: true,
      searchable: false,
    },
  ];

  const sendInvite = () => {
    setLoading(true);
    setInviteInProgres(true);
    actions.inviteMembers(state.enterpriseId, members.map((item) => item.id), () => {
      setLoading(false);
    });
  };

  return (
    <Modal show={members.length > 0} size="lg">
      {inviteInProgres && (
        <div className="text-center">
          {inviteProgressText}
        </div>
      )}

      {!inviteInProgres && (
        <>
          <Table
            title="Invite Members"
            columns={columns}
            data={members}
            selectableRows={false}
          />

          <footer>
            <Button
              variant="outline-primary"
              onClick={() => cancelCallback()}
            >
              Cancel
            </Button>

            <PermissionsGate scopes={{ 'Send Invitation': ['edit'] }}>
              <Button
                onClick={sendInvite}
                disabled={loading}
              >
                {loading && <LoadingPlaceholder placement="inline" />}
                {' '}
                Invite
              </Button>
            </PermissionsGate>
          </footer>
        </>
      )}
    </Modal>
  );
}

Index.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  cancelCallback: PropTypes.func.isRequired,
  sentCallback: PropTypes.func.isRequired,
};
